import { AnimationIcon } from './AnimationIcon';

/**
 * author: Google
 * id 4FE8F135-8FF9-427B-8857-122FBB0A300A
 * name animation
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/animation.svg
 * tags
 */
export const AutoAwesomeMotionIcon = AnimationIcon;
export default AutoAwesomeMotionIcon